import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { getColumnHeaderId as $2140fb2337097f2d$export$37cd4213f2ad742e } from "./utils.module.js";
import $cjB6b$intlStringsmodulejs from "./intlStrings.module.js";
import { isAndroid as $cjB6b$isAndroid, useDescription as $cjB6b$useDescription, mergeProps as $cjB6b$mergeProps } from "@react-aria/utils";
import { useEffect as $cjB6b$useEffect } from "react";
import { useFocusable as $cjB6b$useFocusable } from "@react-aria/focus";
import { useGridCell as $cjB6b$useGridCell } from "@react-aria/grid";
import { useLocalizedStringFormatter as $cjB6b$useLocalizedStringFormatter } from "@react-aria/i18n";
import { usePress as $cjB6b$usePress } from "@react-aria/interactions";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $f329116d8ad0aba0$export$9514819a8c81e960(props, state, ref) {
  var _state_sortDescriptor, _state_sortDescriptor1;
  var node = props.node;
  var allowsSorting = node.props.allowsSorting;
  // if there are no focusable children, the column header will focus the cell
  var _ref = (0, $cjB6b$useGridCell)(_objectSpread({}, props, {
      focusMode: 'child'
    }), state, ref),
    gridCellProps = _ref.gridCellProps;
  var isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === 'single';
  var _ref2 = (0, $cjB6b$usePress)({
      isDisabled: !allowsSorting || isSelectionCellDisabled,
      onPress: function onPress() {
        state.sort(node.key);
      },
      ref: ref
    }),
    pressProps = _ref2.pressProps; // Needed to pick up the focusable context, enabling things like Tooltips for example
  var _ref3 = (0, $cjB6b$useFocusable)({}, ref),
    focusableProps = _ref3.focusableProps;
  var ariaSort = undefined;
  var isSortedColumn = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === node.key;
  var sortDirection = (_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction;
  // aria-sort not supported in Android Talkback
  if (node.props.allowsSorting && !(0, $cjB6b$isAndroid)()) ariaSort = isSortedColumn ? sortDirection : 'none';
  var stringFormatter = (0, $cjB6b$useLocalizedStringFormatter)((0, $parcel$interopDefault($cjB6b$intlStringsmodulejs)), '@react-aria/table');
  var sortDescription;
  if (allowsSorting) {
    sortDescription = "".concat(stringFormatter.format('sortable'));
    // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
    if (isSortedColumn && sortDirection && (0, $cjB6b$isAndroid)()) sortDescription = "".concat(sortDescription, ", ").concat(stringFormatter.format(sortDirection));
  }
  var descriptionProps = (0, $cjB6b$useDescription)(sortDescription);
  var shouldDisableFocus = state.collection.size === 0;
  (0, $cjB6b$useEffect)(function () {
    if (shouldDisableFocus && state.selectionManager.focusedKey === node.key) state.selectionManager.setFocusedKey(null);
  }, [shouldDisableFocus, state.selectionManager, node.key]);
  return {
    columnHeaderProps: _objectSpread({}, (0, $cjB6b$mergeProps)(gridCellProps, pressProps, focusableProps, descriptionProps,
    // If the table is empty, make all column headers untabbable
    shouldDisableFocus ? {
      tabIndex: -1
    } : null), {
      role: 'columnheader',
      id: (0, $2140fb2337097f2d$export$37cd4213f2ad742e)(state, node.key),
      'aria-colspan': node.colspan && node.colspan > 1 ? node.colspan : undefined,
      'aria-sort': ariaSort
    })
  };
}
export { $f329116d8ad0aba0$export$9514819a8c81e960 as useTableColumnHeader };